export class Opportunity {
	constructor(
		public categoryText: string,
		public categoryNo: any,
		public text?: string,
		public assId?: any,
		public orderNo?: number
	) { }
}
